document.addEventListener("DOMContentLoaded", function () {
  // TODO: add a root margin so that the animation between them happens a bit quicker going up or down
  const observerOptions = {
    // threshold: 0.95,
    threshold: 0.92,
    // rootMargin: "1%",
  };

  const HERO_MAIN_SELECTOR = ".section-scroll__main--";
  const LINK_TARGET = ".section-scroll__navigation-item--";

  const highlight = document.querySelector(
    ".scroll-nav .section-scroll__navigation-underline"
  );

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        if (document.body.classList.contains("scroll-up")) {
          const sibling = entry.target.nextElementSibling;

          // if it has a next sibling, then we want to
          if (sibling) {
            const nextProduct = entry.target.dataset.product;
            const nextProductMain = document.querySelector(
              `${HERO_MAIN_SELECTOR}${nextProduct}`
            );

            if (nextProductMain) {
              nextProductMain.classList.add("current-active");
            }

            const currentProduct = sibling.dataset.product;
            const currentProductMain = document.querySelector(
              `${HERO_MAIN_SELECTOR}${currentProduct}`
            );

            if (currentProductMain) {
              currentProductMain.classList.remove("current-active");
            }

            const elLink = document.querySelector(LINK_TARGET + nextProduct);

            if (elLink) {
              const currentActive = document.querySelector(
                ".scroll-nav .section-scroll__navigation-item.active"
              );
              if (currentActive) {
                currentActive.classList.remove("active");
              }
              elLink.classList.add("active");
              highlightLink(elLink, highlight);
            }
          }
        }
      } else {
        const sibling = entry.target.nextElementSibling;

        // if there is a next sibling, transition to it
        // TODO: is this needed?
        if (document.body.classList.contains("scroll-up")) {
          const sibling = entry.target.nextElementSibling;

          // if it has a next sibling, then we want to
          if (sibling) {
            const nextProduct = entry.target.dataset.product;
            const nextProductMain = document.querySelector(
              `${HERO_MAIN_SELECTOR}${nextProduct}`
            );

            if (nextProductMain) {
              nextProductMain.classList.add("current-active");
            }

            const currentProduct = sibling.dataset.product;
            const currentProductMain = document.querySelector(
              `${HERO_MAIN_SELECTOR}${currentProduct}`
            );

            if (currentProductMain) {
              currentProductMain.classList.remove("current-active");
            }

            const elLink = document.querySelector(LINK_TARGET + nextProduct);

            if (elLink) {
              const currentActive = document.querySelector(
                ".scroll-nav .section-scroll__navigation-item.active"
              );
              if (currentActive) {
                currentActive.classList.remove("active");
              }
              elLink.classList.add("active");
              highlightLink(elLink, highlight);
            }
          }
        } else {
          if (sibling) {
            const currentProduct = entry.target.dataset.product;
            const currentProductMain = document.querySelector(
              `${HERO_MAIN_SELECTOR}${currentProduct}`
            );
            if (currentProductMain) {
              currentProductMain.classList.remove("current-active");
            }

            const nextProduct = sibling.dataset.product;
            const nextProductMain = document.querySelector(
              `${HERO_MAIN_SELECTOR}${nextProduct}`
            );
            if (nextProductMain) {
              nextProductMain.classList.add("current-active");
            }

            const elLink = document.querySelector(LINK_TARGET + nextProduct);

            if (elLink) {
              const currentActive = document.querySelector(
                ".scroll-nav .section-scroll__navigation-item.active"
              );
              if (currentActive) {
                currentActive.classList.remove("active");
              }
              elLink.classList.add("active");
              highlightLink(elLink, highlight);
            }
          }
        }
      }
    });
  }, observerOptions);

  const targets = document.querySelectorAll(".section-scroll__main-scroller");

  if (targets) {
    targets.forEach((target) => {
      observer.observe(target);
    });
  }

  // * timeout here helps with the width of the underline on first load
  setTimeout(function () {
    const activeNavElements = document.querySelectorAll(
      ".section-scroll__navigation-item.active"
    );

    if (activeNavElements.length > 0) {
      activeNavElements.forEach((element) => {
        const parentNode = element.parentNode;
        const highlight = parentNode.querySelector(
          ".section-scroll__navigation-underline"
        );
        // check there is a width on the element before running
        if (element.offsetWidth) {
          highlightLink(element, highlight);
        }
      });
    }
  }, 250);
});

function highlightLink(element, highlight) {
  const linkCoords = element.getBoundingClientRect();
  const OVERFLOW_WIDTH = 6;
  const OFFSET_WIDTH = -1;

  highlight.style.width = `${element.clientWidth - OVERFLOW_WIDTH}px`;
  highlight.style.transform = `translateX(${
    element.offsetLeft - OFFSET_WIDTH
  }px)`;
}
